<template>
    <div class="card text-center" :class="cardClassComputed">
        <!-- <img :src="src" class="object-contain mx-auto" @click="onClick()" alt /> -->
        <template v-if="empty">
            <div class="flex items-center h-full w-full justify-center">
                <div class="text-center">
                    <div class="mb-3">
                        <img
                            src="@/assets/icon/misc/icon-add-card.svg"
                            class="mx-auto"
                            alt
                        />
                    </div>
                    <div class="text-primary-50 text-sm">{{ lbl.profile.addCard }}</div>
                </div>
            </div>
        </template>

        <template v-else>
            <div class="absolute bottom-3 left-6 right-10 text-left">
                <div class="text-sm truncate" v-text="info.cardTierName"></div>
                <div class="text-xs" v-text="cardNoComputed"></div>
                <div class="text-sm" v-text="cardHolderNameComputed"></div>
            </div>
            <div class="bg-white absolute top-0 right-0 rounded-tr rounded-bl px-1">
                <button class="outline-none bg-transparent" @click="onClickDeleteCard()">
                    <img src="@/assets/icon/misc/delete.red.svg" />
                </button>
            </div>
        </template>
    </div>
</template>
<script>
import Utility from "@/helper/Utility"
import LocaleMixin from "@/mixin/LocaleMixin"

export default {
    name: 'BankCard',
    props: {
        empty: {
            type: Boolean
        },
        info: {
            /**@type {import("@/types/CreditCardModel.d").CreditCardModel} */
            type: Object,
            default: null
        }
    },
    mixins: [LocaleMixin],
    emits: ["onDeleteCard"],
    computed: {
        cardClassComputed: function () {
            let cls = []
            if (this.empty) {
                cls.push('empty-state')
                cls.push('bg-white')
            } else {
                cls.push('text-white')
                cls.push('relative')
                cls.push('bg-jcb-card')
            }

            return cls
        },
        cardNoComputed: function(){
            return Utility.stringMask(this.info.cardNo, "#### #### #### ####")
        },
        cardHolderNameComputed: function(){
            let name = this.info.cardHolderName.split(" ")
            return name[0] + " " + name[name.length - 1].charAt(0) + '.'
        }
    },
    methods: {
        onClickDeleteCard: function () {
            this.$emit("onDeleteCard", this.info)
        }
    }
}
</script>

<style lang="scss" scoped>
.card {
    img {
        // box-shadow: 0 4px 4px 0 #e0efff;
    }
    box-shadow: 0 0 10px 0 rgba(23, 55, 127, 0.31);
    border-radius: 10px;
    width: 218px;
    height: 137px;
    flex-grow: 0;

    &.empty-state {
        border: dashed 1px #8b9bbf;
        box-shadow: none;
    }

    &.bg-jcb-card {
        background-image: url("~@/assets/img/cards/jcb.svg");
        background-size: cover;
    }
}
</style>
